export const validatorPositive = value => {
    if (value >= 0) {
        return true;
    }
    return false;
};
export const validatorPassword = password => {
    /* eslint-disable no-useless-escape */
    const regExp = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d~!@#$%^&*()_+<>?":`,./;'[\]=\-|\\{}]{8,32}$/;
    /* eslint-enable no-useless-escape */
    const validPassword = regExp.test(password);
    return validPassword;
};
export const validatorStrongPassword = password => {
    /* eslint-disable no-useless-escape */
    const regExp = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@#$%^&*()_+<>?":`,./;'[\]=\-|\\{}])[A-Za-z\d~!@#$%^&*()_+<>?":`,./;'[\]=\-|\\{}]{12,32}$/;
    /* eslint-enable no-useless-escape */
    const validPassword = regExp.test(password);
    return validPassword;
};
export const validatorCreditCard = creditnum => {
    /* eslint-disable no-useless-escape */
    const cRegExp = /^(?:3[47][0-9]{13})$/;
    /* eslint-enable no-useless-escape */
    const validCreditCard = cRegExp.test(creditnum);
    return validCreditCard;
};
function isHttpValid(str) {
    try {
        const newUrl = new URL(str);
        return newUrl.protocol === 'http:' || newUrl.protocol === 'https:';
    }
    catch (err) {
        return false;
    }
}
export const validatorUrlValidator = val => {
    if (val === undefined || val === null || val.length === 0) {
        return true;
    }
    return isHttpValid(val);
};
